/**
 * Schedules a one-shot "open VIP King offer" event a few seconds after a
 * customer successfully PURCHASES a tool unlock (wallet or Razorpay) —
 * unless the user is already a VIP or already inside an active unlock-all
 * window, or we've already shown the upsell in this browser session.
 *
 * The actual modal is owned by <Header> (Layout.jsx), which listens for the
 * "vip:offer:open" custom window event and opens <VipKingOffer />.
 */
const SESSION_KEY = "vip_post_unlock_shown_at";
const COOLDOWN_MS = 30 * 60 * 1000; // don't re-show within 30 minutes

export function maybeOfferVipAfterUnlock(user, delayMs = 5000) {
  // Bail if user already has access
  if (!user) return;
  if (user.is_vip || user.vip_unlocks_all) return;

  // Per-tab session throttle so the user isn't bombarded after unlocking
  // several reports in a row.
  try {
    const lastShown = parseInt(sessionStorage.getItem(SESSION_KEY) || "0", 10);
    if (lastShown && Date.now() - lastShown < COOLDOWN_MS) return;
  } catch {
    /* noop */
  }

  window.setTimeout(() => {
    try { sessionStorage.setItem(SESSION_KEY, String(Date.now())); } catch { /* noop */ }
    window.dispatchEvent(new CustomEvent("vip:offer:open"));
  }, delayMs);
}
